import { CLEAR_SEARCH } from 'ACTIONS';

export const clearAutocomplete = query => ((query || query === '') ? {
    type: CLEAR_SEARCH,
    payload: query
} : { type: CLEAR_SEARCH });
